import {Action} from '@ngrx/store';

export enum SpinnerStatusActionsTypes {
    TOGGLE_SPINNER = '[Modeler Spinner] toggle modeler spinner',
}

export class ToggleModelerSpinner implements Action {
    readonly type = SpinnerStatusActionsTypes.TOGGLE_SPINNER;

}


export type SpinnerStatusActions = ToggleModelerSpinner;
